module.exports = __webpack_public_path__ + "img/businessContactManagers.38165d93.svg";